export default "__VITE_ASSET__1uIAH62Z__"